import { render, staticRenderFns } from "./TypeDeliveryField.vue?vue&type=template&id=1b9431e7&"
import script from "./TypeDeliveryField.vue?vue&type=script&lang=js&"
export * from "./TypeDeliveryField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b9431e7')) {
      api.createRecord('1b9431e7', component.options)
    } else {
      api.reload('1b9431e7', component.options)
    }
    module.hot.accept("./TypeDeliveryField.vue?vue&type=template&id=1b9431e7&", function () {
      api.rerender('1b9431e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/orders/fields/TypeDeliveryField.vue"
export default component.exports